import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DeclineReasonOption } from '../../utils/statistics';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';

// The predefined reasons an owner can pick when declining a reservation
export const DECLINE_REASON_KEYS = [
  COMMON_TRANSLATE_KEYS.CANCEL_RESERVATION_REASON_1,
  COMMON_TRANSLATE_KEYS.CANCEL_RESERVATION_REASON_2,
  COMMON_TRANSLATE_KEYS.CANCEL_RESERVATION_REASON_3,
  COMMON_TRANSLATE_KEYS.CANCEL_RESERVATION_REASON_4,
  COMMON_TRANSLATE_KEYS.CANCEL_RESERVATION_REASON_5,
];

const APP_LANGUAGES = ['bg', 'en'];

/**
 * The decline reason is saved as text in the owner's language at the time,
 * so each option is matched against its text in every app language.
 */
export const useDeclineReasonOptions = (): DeclineReasonOption[] => {
  const { i18n } = useTranslation();

  return useMemo(
    () =>
      DECLINE_REASON_KEYS.map((key) => ({
        key,
        texts: APP_LANGUAGES.map((lng) => i18n.getFixedT(lng)(key)),
      })),
    [i18n]
  );
};
